import type { LumiModuleKey } from '../modules';
import suite from '../assets/modules/suite.webp';
import people from '../assets/modules/people.webp';
import ats from '../assets/modules/ats.webp';
import time from '../assets/modules/time.webp';
import apprentice from '../assets/modules/apprentice.webp';

/** The clay pieces that stand for each module in the switcher (issue 835): its pill and
 * its launcher tiles. Kept apart from the registry on purpose: LUMI_MODULES is read
 * by the landing page too, and the landing loads every raster from /media/ (ADR 0098),
 * so only the badge imports these. A module without a piece (admin) keeps its glyph,
 * and so does every place smaller than the pill — at 16px clay is a smudge. */
export const MODULE_ART: Partial<Record<LumiModuleKey, string>> = {
  suite,
  people,
  ats,
  time,
  apprentice,
};
